module.exports = __webpack_public_path__ + "static/media/bglogin.00431d10.svg";